export const orderClientType = 'fc-platform';
export const orderType = 'b2b-order';
